// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 21101-创建支付 支持钱包、微信等多种支付方式的统一支付接口 POST /app/swim/pay/create */
export async function createPayment(
  body: API.SwimPayCreateReqVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimPayCreateRespVo>("/app/swim/pay/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
